module.exports = __webpack_public_path__ + "img/default.37a30220.png";